import React from 'react'
import PropTypes from 'prop-types'
import ChatSidebarView from '../component/ChatSidebarView'
import AddConversation from '../../AddConversation/container/AddConversation'
import ChatSearch from '../../ChatSearch/container/ChatSearch'
import ChatConversationsList from '../../ChatConversationsList/container/ChatConversationsList'

const ChatSidebar = ({
  addConversation,
  onSearchChange,
  conversations,
  onConversationClick,
  onConversationArchive,
  activeConversationId,
  onRefresh,
  isLoadingConversations,
  loadMoreComponent,
}) => {
  return (
    <ChatSidebarView>
      <AddConversation onClick={addConversation} />
      <ChatSearch onSearchChange={onSearchChange} />
      <ChatConversationsList
        isLoadingConversations={isLoadingConversations}
        conversations={conversations}
        onConversationClick={onConversationClick}
        activeConversationId={activeConversationId}
        onConversationArchive={onConversationArchive}
        onRefresh={onRefresh}
        loadMoreComponent={loadMoreComponent}
      />
    </ChatSidebarView>
  )
}

ChatSidebar.propTypes = {
  onSearchChange: PropTypes.func,
  addConversation: PropTypes.func,
  onConversationClick: PropTypes.func,
  onConversationArchive: PropTypes.func,
  conversations: PropTypes.array,
  activeConversationId: PropTypes.number,
}

export default ChatSidebar
